<div *ngIf='records != null' class="panel-group">
	<div class='srsListAnchor'></div>
	<div *ngFor="let record of records; let i = index;">
		<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" style="margin-bottom:10px;height:230px;">
			<div id="thumbnail_{{record.id}}" class="panel panel-default" style="height:100%;position:relative;">
				<div class="panel-heading">
					<div class="row">
						<div class="col-xs-11">
							<label class="col-xs-1 control control--checkbox">
                      			<!-- [checked] is one-way binding, unlike [(ngModel)] -->
                    			<input type="checkbox" [checked]="globalRecordService.globalRecordIdsHash[record.id]" (change)="toggleRecordId(record.id)" [attr.aria-label]="'Select ' + record.title" />
								<div class="control__indicator"></div>
							</label>                    			
								<span class="result-title truncate-link thumbnailViewTitle">
									<span *ngIf="additionalIcons" class="result-icons-container">
										<span>{{record._index}}. </span>
										<i title="{{LOCALIZATION.viewMetadata}}" (click)="viewMetadata(record.id)" class="fa fa-tags" aria-hidden="true"></i>
										<i title="{{LOCALIZATION.viewInMap}}" *ngIf="record.geo && mapViewEnabled" (click)="openInMap(record)" class="fa fa-globe-americas" aria-hidden="true"></i>
										<i title="{{LOCALIZATION.recordInformation}}" *ngIf="userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW'] && record.rm_record_id" (click)="viewRMQuickInfo(record.id)" class="fas fa-folder" aria-hidden="true"></i>
									</span>
									<a title="{{ record._decoded['title'] }}" class='pointMe'
									   [ngClass]="{'visited': visited[record.id],'unvisited' : !visited[record.id]}"
									   (click)="openRecord(record.id)">
									   	<span [innerHTML]="record.title"></span>
									</a>
								</span>
						</div>
						<div class="col-xs-1 nopads">
			                    <div class="dropdown" ngbDropdown>
								  <button ngbDropdownToggle
									  type="button"
									  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
									  aria-haspopup="true"
									  aria-expanded="false"
									  [attr.aria-label]="LOCALIZATION.more"
									  title="{{LOCALIZATION.more}}"
									  style="border: 0; background: transparent;">
										<i class="result-nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
								  </button>								  
			                      <ul class="dropdown-menu dropdown-menu-results custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
									<li *ngIf="record.geo && mapViewEnabled" role="menuitem">
										<a title="{{LOCALIZATION.viewInMap}}" (click)="openInMap(record)">{{LOCALIZATION.viewInMap}}</a>
									</li>
									<li role="menuitem">
										<a title="{{LOCALIZATION.viewMetadata}}" (click)="viewMetadata(record.id)">{{LOCALIZATION.viewMetadata}}</a>
									</li>
									<li *ngIf="isMoreLikeThisEnabled" role="menuitem">
										<a title="{{LOCALIZATION.viewMoreLike}}" (click)="searchSimilarDocs(record)">{{LOCALIZATION.viewMoreLike}}</a>
									</li>
		                            <ng-container *ngIf="streamingQueries && streamingQueries['enabled']">
			                            <li *ngFor="let streamingQueryType of streamingQueries['types']" role="menuitem">
			                            	<a title="{{streamingQueryType.displayName}}" (click)="searchByStreamingQuery(record, streamingQueryType.name, streamingQueryType.displayName)">{{streamingQueryType.displayName}}</a>
			                            </li>
		                            </ng-container>
									<li *ngIf="cartOn" role="menuitem">
										<a title="{{LOCALIZATION.addDocToCart}}" (click)="addToCart(record)">{{LOCALIZATION.addDocToCart}}</a>
									</li>
									<li *ngIf="tagsEnabled && userPermissions['ROLE_PRODUCT_UPDATE']" role="menuitem">
										<a title="{{LOCALIZATION.viewTags}}" (click)="viewTags(record.id, i)">{{LOCALIZATION.viewTags}}</a>
									</li>
									<li *ngIf="userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW'] && record.rm_record_id" role="menuitem">
										<a title="{{LOCALIZATION.recordInformation}}" (click)="viewRMQuickInfo(record.id)">{{LOCALIZATION.recordInformation}}</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="panel-body text-center" style="padding-top:0px">
                    <img (click)="openRecord(record.id)" 
                    	class='img-thumbnail pointMe img-responsive' style="max-height:145px"
                    	alt="Thumbnail for {{record.title}}"
                    	loading="lazy" 
                    	[src]="record._thumbs" 
                        onerror="this.src='/app/aw-ui-angular/assets/img/product_default_thumbnail.webp'" />						
				</div>
			</div>
		</div>
	</div>
</div>
